import { CountryCurrencies } from "@/constants/currencies"
import { CountryCode } from "libphonenumber-js"

export interface Plan {
  id: string
  name: string
  key: PlanNames
  price: Price
  prices: Record<Partial<CountryCode | "EUR">, Price>
  isSubscribed: boolean
  icon: string
  description: string
}

export interface PlanFeatures {
  orderQuotes: number
  additionalOrderPrice: number
  liveDeliveryTracking?: boolean
  accessToProviders?: boolean
  apiIntegrations?: boolean
  multiStops?: boolean
  routeOptimization?: boolean
  brandedTrackingPage?: boolean
  customerNotifications?: boolean
  haveMultipleStores?: boolean
  unlimitedProviders?: boolean
  ruleWorkflows?: string
  allowedUpgradeTo: string[]
  driverApp?: boolean
  maxFiveDrivers?: boolean
  orderQuotesDescription: number
  premiumOnboarding?: boolean
}

export enum PlanNames {
  FREE = "free",
  LAUNCH = "launch",
  GROW = "grow",
  OPTIMIZATION = "optimization",
}

export type EnrichedPlan = Plan & PlanFeatures

export interface Subscription {
  startPeriod: number
  endPeriod: number
  product: EnrichedPlan
  createdOrderInPeriod: number
  cancelAtPeriodEnd: boolean
}

export const activePlanFeatures = {
  "free": [
    "driverApp",
    "liveDeliveryTracking",
    "proofOfDelivery",
    "automatedNotifications",
    "maxFiveDrivers",
  ],
  "launch": [
    "accessToProviders",
    "ownDrivers",
    "proofOfDelivery",
    "multiStops",
    "automatedNotifications",
  ],
  "grow": [
    "everythingInLaunch",
    "teamsAndZones",
    "optimizationAndBatching",
    "statusNotifications",
    "brandedTrackingPage",
  ],
  "optimization":
    [
      "everythingInGrow",
      "premiumOnboarding",
      "autoDispatch",
      "ownCouriersAccounts",
      "customSolutions",
      "orderQuotesDescription",
    ],

}

export interface Price {
  id: string
  amount: number
  currency: CountryCurrencies
}
